import { wallet as o } from "../store/index.mjs";
import { getOptionList as i } from "../subgraph-api.mjs";
import { commonOwner as c } from "../util/common.mjs";
import { getReward as l } from "./staking_pool_rewarder.mjs";
import { useSniperNickname as d } from "../util/sniperNameFormat.mjs";
import { BaseTokenSymbol as s } from "./token_provider.mjs";
import { getHODLPoolRewardAmount as w } from "./hodl_pool_rewarder.mjs";
import { useDOBStakingPoolContract as e } from "../store/dobStakingPoolContract.mjs";
const O = c(e);
function g(t) {
  return e(!0).stake(t);
}
function L(t) {
  return e(!0).unstake(t);
}
function T() {
  const t = o?.getAddress();
  if (t == null) throw new Error("Please connect wallet first.");
  return e().getReward(t).then((r) => {
    const { bHODLReward: n, ...a } = r.toObject();
    return {
      ...a,
      sellTokenHODLReward: n
    };
  });
}
function b(t) {
  const r = t ?? o?.getAddress();
  if (r == null) throw new Error("Please connect wallet first.");
  return e().userDatas(r).then((n) => {
    const { bHODLEntryAccuReward: a, ...u } = n.toObject();
    return {
      ...u,
      sellTokenHODLEntryAccuReward: n.bHODLEntryAccuReward
    };
  });
}
async function H(t) {
  return await e().activatedOptions(t);
}
async function S() {
  return await e().activatedOptionLength();
}
async function B() {
  return await e().lastPeriodDailyTotalShareBullet();
}
async function C() {
  return await e().lastWorkTimestamp();
}
async function A(t) {
  const r = t ?? o?.getAddress();
  if (r == null) throw new Error("Please connect wallet first.");
  return await e().stakingInfo(r);
}
async function E(t) {
  const r = t ?? o?.getAddress();
  if (r == null) throw new Error("Please connect wallet first.");
  return await e().userClaimInfo(r);
}
async function P() {
  return await e(!0).pause();
}
async function F(...t) {
  return await e(!0).setIsCheckNFT(...t);
}
async function v() {
  return await e().isCheckNFT();
}
async function I() {
  return await e().NFTAddress();
}
async function N() {
  return await e().remainingBulletCollector();
}
async function x() {
  return await e().lastDeliverStartBlock();
}
async function W() {
  return await e().lastDeliverEndBlock();
}
function j() {
  return e().extendLockDays();
}
function U(...t) {
  return e(!0).setExtendLockDays(...t);
}
function $(t) {
  return e().poolData({
    blockTag: t
  });
}
function q() {
  return e().bulletRewardThreshold();
}
function z() {
  return e(!0).redeemReward();
}
function G() {
  return e().rewardDispatcher();
}
function J() {
  return e().dailyTotalShareBullet();
}
function K() {
  return e().uHODLRewarder();
}
async function M(...t) {
  return await e(!0).setuHODLRewarder(...t);
}
function Q() {
  return e().bHODLRewarder();
}
async function V(...t) {
  return await e(!0).setbHODLRewarder(...t);
}
function X() {
  return e().feeCollector();
}
function Y() {
  return e().bulletCollector();
}
function Z(t, r) {
  return e(!0).drawReward(t, r);
}
function _() {
  return e().worker();
}
function tt(t) {
  return e(!0).setWorker(t);
}
function et() {
  return e().bulletRewardThreshold();
}
async function rt() {
  return await e().optionFactory();
}
async function nt(...t) {
  return await e(!0).setFactory(...t);
}
function at(...t) {
  return e(!0).setBulletRewardThreshold(...t);
}
async function ot(t) {
  const r = t === s.UHODL ? "1" : "2", n = await w(r);
  return {
    id: r,
    name: t,
    from: t,
    rewardAmount: n.toString()
  };
}
async function ut(t = o?.getAddress()) {
  const r = await i({
    address: t,
    isActive: !0,
    isStarted: !0
  }), n = [];
  return await Promise.all(
    r.map(async (a) => {
      const u = await l(a.id);
      n.push({
        id: a.id,
        from: a.optionType === "0" ? s.SellTokenSNIPER : s.USNIPER,
        name: d(r, a) ?? "",
        rewardAmount: u.toString()
      });
    })
  ), n;
}
export {
  I as NFTAddress,
  S as activatedOptionLength,
  H as activatedOptions,
  Q as bHODLRewarder,
  Y as bulletCollector,
  et as bulletRewardThreshold,
  J as dailyTotalShareBullet,
  Z as drawReward,
  j as extendLockDays,
  X as feeCollector,
  q as getBulletRewardThreshold,
  ot as getHODLReward,
  T as getReward,
  ut as getSniperReward,
  v as isCheckNFT,
  W as lastDeliverEndBlock,
  x as lastDeliverStartBlock,
  B as lastPeriodDailyTotalShareBullet,
  C as lastWorkTimestamp,
  rt as optionFactory,
  O as owner,
  P as pause,
  $ as poolData,
  z as redeemReward,
  N as remainingBulletCollector,
  G as rewardDispatcher,
  at as setBulletRewardThreshold,
  U as setExtendLockDays,
  nt as setFactory,
  F as setIsCheckNFT,
  tt as setWorker,
  V as setbHODLRewarder,
  M as setuHODLRewarder,
  g as stake,
  A as stakingInfo,
  K as uHODLRewarder,
  L as unstake,
  E as userClaimInfo,
  b as userDatas,
  _ as worker
};
//# sourceMappingURL=dob_staking_pool.mjs.map
